import { Amplify, Storage } from 'aws-amplify';
import { nanoid } from 'nanoid';
import { toBlob } from '#lib/utils/file.js';
import useAsync from '#lib/hooks/use-async.js';
import { isFunction } from '#lib/utils/function.js';

function sanitizeNotAsciiValue(value) {
    return value.replace(/[^\x00-\xFF]/g, ''); // rimuove caratteri non ISO-8859-1
}

export async function uploadS3Core(event) {
    Amplify.configure({
        Auth: {
            identityPoolId: COGNITO_IP_ID,
            region: AWS_REGION
        },
        Storage: {
            AWSS3: {
                bucket: PUBLIC_BUCKET_NAME,
                region: AWS_REGION
            }
        }
    });

    Storage.configure({
        customPrefix: {
            public: ''
        }
    });

    const [firstFile] = event.target.files;
    const { name, data, type } = await toBlob(firstFile);

    const extension = name.split('.')[1];
    let key = `upload_tmp/${nanoid()}.${extension}`;
    let config = {
        metadata: { originalFileName: sanitizeNotAsciiValue(name) },
        tagging: 'temp=1'
    };

    if (type) config.contentType = type;
    const res = await Storage.put(key, data, config);
    const tempKey = res?.key;
    if (!tempKey) throw Error(`temp key not generated`);
    return { file: firstFile, tempKey };
}

export default function useS3Upload(options) {
    const onBeforeUpload = options?.onBeforeUpload;

    const s3Upload = useAsync(uploadS3Core, options);
    const onChange = (e) => {
        let allowUpload = true;
        if (isFunction(onBeforeUpload)) allowUpload = onBeforeUpload(e);
        if (!allowUpload) return false;
        s3Upload.execute(e);
        return true;
    };

    const onChangeAsync = async (e) => {
        let allowUpload = true;
        if (isFunction(onBeforeUpload)) allowUpload = onBeforeUpload(e);
        if (!allowUpload) return false;
        await s3Upload.execute(e);
        return true;
    };
    const onClear = s3Upload.clear;

    return {
        data: s3Upload.data,
        uploadLoading: s3Upload.isLoading,
        props: { onChange, onChangeAsync, onClear }
    };
}